/* ==========================================================================
   segmented-control.js
   --------------------------------------------------------------------------
   Auto-wires every .cc-segmented in the DOM:
     - Click handler slides the thumb to the clicked button's index
     - Keyboard: Left/Right arrows move focus, Home/End jump to ends,
       Enter/Space activate the focused button
     - aria-selected + tabindex stay in sync with the active state
     - Dispatches `cc-segmented:change` with detail { index, button }
       for sections that want to react via event listener (existing
       section JS can also stay attached to the buttons' click events
       — both fire fine).

   This script does NOT call into any panel-show/hide logic itself.
   The existing per-section click handlers (FAQ audience swap, showcase
   product toggle, etc.) continue to fire on the same buttons.
   ========================================================================== */

(function () {
  'use strict';

  function setActive(seg, idx) {
    var btns = seg.querySelectorAll('.cc-segmented__btn');
    if (idx < 0 || idx >= btns.length) return;
    var thumb = seg.querySelector('.cc-segmented__thumb');
    if (thumb) thumb.style.transform = 'translateX(' + (idx * 100) + '%)';
    btns.forEach(function (b, i) {
      var on = i === idx;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.setAttribute('tabindex', on ? '0' : '-1');
    });
    seg.dispatchEvent(new CustomEvent('cc-segmented:change', {
      bubbles: true,
      detail: { index: idx, button: btns[idx] }
    }));
  }

  function init(seg) {
    var btns = seg.querySelectorAll('.cc-segmented__btn');
    if (!btns.length) return;

    /* Initial thumb position: find any pre-set active button (or default 0). */
    var initialIdx = 0;
    btns.forEach(function (b, i) {
      if (b.getAttribute('aria-selected') === 'true' || b.classList.contains('is-active')) {
        initialIdx = i;
      }
    });
    /* Set immediately without transition so the thumb starts in the right
       place on first paint. Done by suppressing transition for one frame. */
    var thumb = seg.querySelector('.cc-segmented__thumb');
    if (thumb) {
      var prevTransition = thumb.style.transition;
      thumb.style.transition = 'none';
      thumb.style.transform = 'translateX(' + (initialIdx * 100) + '%)';
      /* Force reflow then restore transition. */
      void thumb.offsetWidth;
      thumb.style.transition = prevTransition;
    }

    btns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        setActive(seg, i);
      });
      b.addEventListener('keydown', function (e) {
        var key = e.key;
        if (key === 'ArrowRight' || key === 'ArrowDown') {
          e.preventDefault();
          var next = (i + 1) % btns.length;
          btns[next].focus();
          setActive(seg, next);
        } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
          e.preventDefault();
          var prev = (i - 1 + btns.length) % btns.length;
          btns[prev].focus();
          setActive(seg, prev);
        } else if (key === 'Home') {
          e.preventDefault();
          btns[0].focus();
          setActive(seg, 0);
        } else if (key === 'End') {
          e.preventDefault();
          btns[btns.length - 1].focus();
          setActive(seg, btns.length - 1);
        } else if (key === 'Enter' || key === ' ') {
          e.preventDefault();
          setActive(seg, i);
          /* Also fire click so existing per-section handlers run. */
          b.click();
        }
      });
    });
  }

  function bootAll() {
    document.querySelectorAll('.cc-segmented').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
})();
